import config from "../../config.json"
import ColorPicker from "../colorPicker/ColorPicker"
import FileUpload from "../fileUpload/FileUpload"
import TextEditor from "../textEditor/TextEditor"
import RadioButton from "../radioButton/RadioButton"
import TextArea from "../textArea/TextArea"
import FontFamily from "../fontFamily/FontFamily"
import Checkbox from "../checkbox/Checkbox"
import MultiLanguageSelector from "../multiLanguage/MultiLanguageSelector"

/**
 * Dynamic component router that renders form elements based on configuration.
 * Maps element types to their corresponding React components and conditionally
 * shows the MultiLanguageSelector for the "Textes" tab.
 * @param {Object} props
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @param {Function} props.onLanguagesChange - Callback for language selection changes
 * @param {boolean} props.overlayChecked - Overlay checkbox state
 * @param {Function} props.setOverlayChecked - Overlay checkbox toggle function
 * @param {boolean} props.highlightStrokeChecked - Highlight stroke checkbox state
 * @param {Function} props.setHighlightStrokeChecked - Highlight stroke checkbox toggle function
 * @returns {JSX.Element}
 */
function TabContent({ parameters, setParameters, onLanguagesChange, overlayChecked, setOverlayChecked, highlightStrokeChecked, setHighlightStrokeChecked }) {
  return (
    <div className="tab-content">
      {config.tabContent[parameters.selectedTab].map((element, index) => {
        switch (element.type) {
          case "ColorPicker":
            if (element.id === "modalShadowBgColor") {
              return (
                <ColorPicker
                  key={index}
                  element={element}
                  parameters={parameters}
                  setParameters={setParameters}
                  overlayChecked={overlayChecked}
                  onToggleOverlay={setOverlayChecked}
                />
              )
            }
            if (element.id === "modalHighlightColor") {
              return (
                <ColorPicker
                  key={index}
                  element={element}
                  parameters={parameters}
                  setParameters={setParameters}
                  highlightStrokeChecked={highlightStrokeChecked}
                  onToggleHighlightStroke={setHighlightStrokeChecked}
                />
              )
            }
            return <ColorPicker key={index} element={element} parameters={parameters} setParameters={setParameters} />
          case "FileUpload":
            return <FileUpload key={index} element={element} parameters={parameters} setParameters={setParameters} />
          case "RadioButton":
            return <RadioButton key={index} element={element} parameters={parameters} setParameters={setParameters} />
          case "TextArea":
            return <TextArea key={index} element={element} parameters={parameters} setParameters={setParameters} />
          case "FontFamily":
            return <FontFamily key={index} element={element} parameters={parameters} setParameters={setParameters} />
          case "Checkbox":
            return <Checkbox key={index} element={element} parameters={parameters} setParameters={setParameters} />
          default:
            return <TextEditor key={index} element={element} parameters={parameters} setParameters={setParameters} />
        }
      })}
      {parameters.selectedTab === "Textes" && <MultiLanguageSelector onLanguagesChange={onLanguagesChange} />}
    </div>
  )
}

export default TabContent
